import ResourcePage from "@/components/common/ResourcePage";
import { Badge } from "@/components/common/DataTable";

export default function ModulesPage() {
  return (
    <ResourcePage
      title="Modules" subtitle="Master module catalogue (commercial building blocks)"
      base="/v1/modules" perm="MODULE"
      columns={[
        { key: "moduleCode", header: "Code", render: (r) => <span className="font-mono text-xs font-semibold">{r.moduleCode}</span> },
        { key: "moduleName", header: "Name" },
        { key: "commercialCategory", header: "Category", render: (r) => <Badge color="blue">{r.commercialCategory}</Badge> },
        { key: "dependencies", header: "Dependencies", render: (r) => (r.dependencies || []).join(", ") || "—" },
      ]}
      fields={[
        { name: "moduleCode", label: "Module Code", placeholder: "CRM", immutable: true },
        { name: "moduleName", label: "Module Name" },
        { name: "description", label: "Description" },
        { name: "commercialCategory", label: "Commercial Category", type: "select", options: ["Core CRM", "Core Enterprise", "Enterprise AI", "Integration", "Platform", "Control Plane", "Channel Add-on"] },
        { name: "dependencies", label: "Dependencies (comma separated codes)", type: "tags" },
        { name: "status", label: "Status", type: "select", options: ["Active", "Inactive"] },
      ]}
    />
  );
}
